'use-strict';

module.exports = ['$scope', 'ngDroUAA', '$interval', function ($scope, ngDroUAA, $interval) {


        $scope.$watch('company', function () {
            if ($scope.company && $scope.company.id) {
                ngDroUAA.Person.findOneByCompanyDistrict($scope.company.id).then(function (response) {
                    $scope.persons = response.data;
                });
            }
        });
        
        ngDroUAA.Company.findAll().then(function (response) {
            $scope.companies = response.data;
        });
    }];


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/components/company/companyDetail/tabs/company-person.js
// module id = 421
// module chunks = 0